export default {
    application: {
        Production: true,
        PreProduction: true,
        UAT: true,
        SVT: true,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    advanceDownload: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    orderListColumnChanges: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: false,
        Mock: false,
        Development: false,
        Local: false
    },
    displayRamboProductCategory: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: true,
        Mock: false,
        Development: true,
        Local: false
    },
    legacyOrderDetailsSubStageStatus: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    hideDatefieldNoDataFromDownstream: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    tedig3296UpliftedOrderDetails: {
        Production: {bvtEnabledFeature: false, flagState: false},
        PreProduction: {bvtEnabledFeature: false, flagState: false},
        UAT: {bvtEnabledFeature: false, flagState: false},
        SVT: {bvtEnabledFeature: false, flagState: false},
        QA: {bvtEnabledFeature: true, flagState: true},
        Mock: {bvtEnabledFeature: true, flagState: true},
        Development: {bvtEnabledFeature: true, flagState: true},
        Local: {bvtEnabledFeature: true, flagState: true}
    },
    tedig3007OrderListChanges: {
        Production: {bvtEnabledFeature: false, flagState: false},
        PreProduction: {bvtEnabledFeature: false, flagState: false},
        UAT: {bvtEnabledFeature: false, flagState: false},
        SVT: {bvtEnabledFeature: false, flagState: false},
        QA: {bvtEnabledFeature: true, flagState: true},
        Mock: {bvtEnabledFeature: true, flagState: true},
        Development: {bvtEnabledFeature: true, flagState: true},
        Local: {bvtEnabledFeature: true, flagState: true}
    },
    tedig3007OrderListPart2: {
        Production: {bvtEnabledFeature: false, flagState: false},
        PreProduction: {bvtEnabledFeature: false, flagState: false},
        UAT: {bvtEnabledFeature: false, flagState: false},
        SVT: {bvtEnabledFeature: false, flagState: false},
        QA: {bvtEnabledFeature: true, flagState: true},
        Mock: {bvtEnabledFeature: true, flagState: true},
        Development: {bvtEnabledFeature: true, flagState: true},
        Local: {bvtEnabledFeature: true, flagState: true}
    },
    tedig4307Dynamic5g: {
        Production: {bvtEnabledFeature: false, flagState: false},
        PreProduction: {bvtEnabledFeature: false, flagState: false},
        UAT: {bvtEnabledFeature: false, flagState: false},
        SVT: {bvtEnabledFeature: false, flagState: false},
        QA: {bvtEnabledFeature: false, flagState: true},
        Mock: {bvtEnabledFeature: false, flagState: true},
        Development: {bvtEnabledFeature: false, flagState: true},
        Local: {bvtEnabledFeature: false, flagState: true}
    },
    orderTrackerIntUIUpliftment: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: false,
        Mock: true,
        Development: false,
        Local: false
    },
    orderTrackerDetailsIntUIUpliftment: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: false,
        Mock: true,
        Development: false,
        Local: false
    },
    disablePdfDownloadInt: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: true,
        QA: false,
        Mock: true,
        Development: false,
        Local: false
    }
};
